export const designGalleryStyles = {
  wrapper: {
    margin: {
      mobile: "7.5rem 1.5rem",
      laptop: "7rem 4rem",
      desktop: "10rem 0",
    },
    alignItems: "center",
    justifyContent: "center",
  },
};
